'use es6';

export const LOADING = 'LOADING';

export const CALLOUT = 'CALLOUT';

export const EMAIL = 'EMAIL';

export const QUESTION = 'QUESTION';

export const FOLLOW_UP = 'FOLLOW_UP';

export const NO_SURVEY = 'NO_SURVEY';

export const THANK_YOU = 'THANK_YOU';

export const ERROR = 'ERROR';
